import React, { FC, memo, useCallback, useEffect, useMemo, useState } from "react"
import { observer } from "mobx-react-lite"
import {
  Appearance,
  ImageStyle,
  SectionListRenderItemInfo,
  ViewStyle,
  Platform,
  TextInput,
  useWindowDimensions,
  InteractionManager,
  TouchableOpacity,
} from "react-native"
import {
  AutoImage,
  FormControl,
  JalaIcon,
  ModelPicker,
  Screen,
  Text,
  useAutoFeederPond,
  Button,
  Input,
  OfflineMode,
} from "../../../../components"
import { useStores } from "../../../../models"
import { color } from "../../../../theme"
import { CompositeScreenProps, useFocusEffect, useIsFocused } from "@react-navigation/native"
import { navigate } from "../../../../navigators"
import { FlatList, Spinner, Toast, View } from "native-base"
import { PondStore, PondStoreModel } from "../../../../models/app-store/farm-store/pond-store/pond-store"
import moment from "moment"
import { translate, TxKeyPath } from "../../../../i18n"
import { Edge, SafeAreaView } from "react-native-safe-area-context"
import _ from "lodash"
// import { TouchableOpacity } from "react-native-gesture-handler"
import { delay } from "../../../../utils/delay"
import { AutoFeederPond, Farm } from "../../../../database"
import {
  requestAccessFineLocationPermission,
  requestBluetoothConnectPermission,
  requestBluetoothScanPermission,
} from "../../../../utils/permissions"
import { FarmStoreModel } from "../../../../models/app-store/farm-store/farm-store"
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"
import JalaAnalytic from "../../../../utils/jala-analytic"
// import { CalibrationInfo } from "../../auto-feeder-pond/auto-feeder-pond-detail/auto-feeder-pond-detail-screen"

const ROOT: ViewStyle = {
  flex: 1,
}

const FLAT_LIST: ViewStyle = {
  paddingBottom: 68,
}

const TOP_BAR_CONTAINER: ViewStyle = {
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row"
}

const EMPTY_BUTTON: ViewStyle = {
  marginTop: 25,
  width: 230,
  backgroundColor: color.primary
}

const FORM_DROPDOWN: ViewStyle = {
  paddingHorizontal: 16,
  paddingBottom: 8
}

const ASTO_IMAGE: ImageStyle = {
  width: 65,
  height: 70,
  resizeMode: 'contain',
}

const EMPTY_ASTO_IMAGE: ImageStyle = {
  width: '80%',
  height: 215,
  resizeMode: 'contain',
}

const ADD_BUTTON: ViewStyle = {
  flexDirection: "row",
  alignItems: "center"
}

const HEADER_CONTAINER = (height): ViewStyle => ({
  justifyContent: "space-between",
  flexDirection: "row",
  alignItems: 'center',
  backgroundColor: color.primary,
  height: height
})

const HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const BACK_BUTTON: ViewStyle = {
  marginLeft: 16,
  marginRight: 12
}

const TOP_BAR_SEARCH_BUTTON: ViewStyle = {
  marginRight: 16,
}

const SEARCH_HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
}

const TEXT_FIELD: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  marginVertical: 0,
  paddingVertical: 0,
  backgroundColor: 'green',
  minHeight: 35
}

const BTN_CANCEL: ViewStyle = {
  marginHorizontal: 16
}

const ICON_PRO: ViewStyle = {
  width: 13.5,
  height: 13.5,
  borderRadius: 13.5/2,
  backgroundColor: color.palette.orange500,
  alignItems: 'center',
  marginLeft: 3
}

const asto = require("./asto.png")
const empty = require("./empty-asto.png")

export const AutoFeederHeader: FC<CompositeScreenProps<any, any>> = observer(function AutoFeederHeader(props){
  const { navigation, route } = props;
  const { appStore: { farmStore } } = useStores()

  const onRefresh = useCallback(() => {
    farmStore.getPonds(true, () => {
      farmStore.getAutoFeederPonds(true)
    });
  }, [farmStore])


  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';
  const colorScheme = "light"
  const inputRef = React.useRef<TextInput>()
  const isFocused = useIsFocused()

  const data = route && route.params && route.params.data || []
  const headerHeight = 55.8;
  const [ hidden, setHide ] = useState<boolean>(true);
  const handleChangeText = _.throttle((text) => {
    navigation.setParams({ data: { ...data, text } });
    JalaAnalytic.log('Mobile App: Auto Feeder - Search', { search: text })
  }, 500);
  const handleCancel = () => {
    setHide(!hidden);
    navigation.setParams({ data: { ...data, text: "" } })
  }

  return (<View backgroundColor={color.primary}>
    <SafeAreaView edges={["top"]} />
    {isFocused && <View style={HEADER_CONTAINER(headerHeight)}>
      {hidden ? (
        <>
          <View style={HEADER}>
            <Button testID="jala:id/back-button" preset="link" textPreset="display1" style={BACK_BUTTON}
              colorScheme={colorScheme} onPress={navigation.goBack}>
              <JalaIcon name={backIcon} size={25} color={color.palette.white} />
            </Button>
            <Text tx="farmAutoFeederPondListScreen.astoList" preset="title2" color={color.palette.white} />
          </View>
          <View style={TOP_BAR_CONTAINER}>
            <Button testID="jala:id/qr-scan-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON} onPress={() => navigate("Home.Stack", "Home.AutofeederPond.Create.QRScan")}>
              <MaterialCommunityIcons name="line-scan" size={24} color={color.palette.white} />
            </Button>
            <Button testID="jala:id/refresh-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON} onPress={onRefresh}>
              <JalaIcon name="refresh" size={24} color={color.palette.white} />
            </Button>
            <Button testID="jala:id/search-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON}
              onPress={() => setHide(!hidden)}>
              <JalaIcon name="search" size={24} color={color.palette.white} />
            </Button>
          </View>
        </>
      ) : (
        <View style={SEARCH_HEADER}>
          <Input ref={inputRef} style={TEXT_FIELD} placeholderTx="searchPondPlaceholder" borderRadius="40px" px="12px"
            ml="16px" backgroundColor={color.palette.white} onChangeText={handleChangeText} />
          <Button testID="jala:id/cancel-button" preset="link" textPreset="title3" textColor={color.palette.white}
            style={BTN_CANCEL} onPress={handleCancel} tx="cancel" colorScheme="light" />
        </View>
      )}
    </View>}
  </View>)
})

const SectionHeader: FC<{ colorScheme?: "light" | "dark", info?: any, hiddenPonds?: any, setIsShow?: (pondId?: number) => void }> = observer(function SectionHeader(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    info,
    // hiddenPonds, setIsShow
  } = props;

  const pondStore = PondStoreModel.create(info.item.title)

  const pondText = pondStore.todayCycle ?
    `${pondStore?.pond?.name} (${pondStore?.todayCycle?.age})` :
    `${pondStore?.pond?.name}`;

  const cycleStore = pondStore.cycleStoreModels.length ? pondStore.cycleStoreModels[0] : null
  const startCycle = cycleStore ? moment(cycleStore.cycle.started_at).format('DD MMM YYYY') : '-'
  const finishCycle = cycleStore && cycleStore.cycle.finished_at ? moment(cycleStore.cycle.finished_at).format('DD MMM YYYY') : translate("now")

  const isPro = pondStore.pond.pro

  return (
    <View paddingBottom="8px" paddingX="16px" backgroundColor="white" paddingTop="15px">
      <View flexDirection="row" justifyContent="space-between" alignItems="center">
        <View>
          <View flexDirection="row" alignItems="center">
            <Text text={pondText} preset="title3" colorScheme={colorScheme}></Text>
            {isPro && <View style={ICON_PRO}>
              <JalaIcon name="premium" size={12} color={color.palette.white} />
            </View>}
          </View>
          <Text text={`${startCycle} - ${finishCycle}`} preset="body3" colorScheme={colorScheme} color={color.palette.gray600}></Text>
        </View>
        {/* <TouchableOpacity onPress={onSetHiddenShow}>
          <JalaIcon name={icon()} size={20} color={color.palette.gray800} />
        </TouchableOpacity> */}
        {/* <Text text={translate("farmAutoFeederPondListScreen.feed", { feed: feedText })} preset="title4" colorScheme={colorScheme} color={`gray.${colorScheme === 'light' ? '600' : '400' }`} /> */}
      </View>
    </View>
  )
})

const AutoFeederitem: FC<{ colorScheme?: "light" | "dark", item?: any, isLast?: boolean, pondId?: number }> = observer(function AutoFeederitem(props) {
  const { colorScheme, item, isLast, pondId } = props;

  const { appStore: { farmStore } } = useStores()
  const { setAutoFeederPond } = useAutoFeederPond()

  // const model = AutoFeederPond.hydrate(item)
  // const todayDate = moment().format('YYYY-MM-DD');
  // const tomorrowDate = moment().add(1, 'day').format('YYYY-MM-DD');
  // const todayFeed = (item.state?.feeds || []  ).find((datum) => datum.feed_at === todayDate)
  // const tomorrowFeed = (item.state?.feeds || []  ).find((datum) => datum.feed_at === tomorrowDate)
  // const todayFeedText = (todayFeed ? numeral(todayFeed.quantity).format('0,0.[00]') : '-') + ' kg';
  // const tomorrowFeedText = (tomorrowFeed ? numeral(tomorrowFeed.quantity).format('0,0.[00]') : '-') + ' kg';
  const updatedAt = item.state?.updatedAt || item.state?.uploadedAt || item.updated_at;
  const lastUpdate = updatedAt && _.upperFirst(moment.utc(updatedAt).local().fromNow()) || '-'
  const lastUploaded = item.state?.uploadedAt && _.upperFirst(moment.utc(item.state?.uploadedAt).local().fromNow()) || '-'
  const needUpload = item.state?.uploadedAt && item.state.uploadedAt < updatedAt;
  const astoId = !!item.name && item.auto_feeder_address || '-';

  const onNavigateSetting = useCallback(async () => {
    farmStore.pondStore.set('autoFeederPondId', item.id)
    await delay(1)
    setAutoFeederPond(AutoFeederPond.hydrate(item))
    navigate('Home.Stack', 'Home.AutoFeederPond.Edit')
  }, [farmStore.pondStore, item, setAutoFeederPond])

  const onPressItem = useCallback(async () => {
    farmStore.set('pondId', pondId)
    farmStore.pondStore.set('cycleId', farmStore.pondStore.activeCycle?.id)
    farmStore.pondStore.set('autoFeederPondId', item.id)
    setAutoFeederPond(AutoFeederPond.hydrate(farmStore.pondStore.autoFeederPond))
    JalaAnalytic.log('Mobile App : Detail Asto');
    await delay(1)
    navigate('Home.AutoFeederPond.Stack', 'Home.AutoFeederPond.Detail.Stack', { id: item.id })
  }, [farmStore, pondId, item, setAutoFeederPond])

  return (
    <View borderBottomWidth={isLast ? 0 : 1} borderBottomColor={color.palette.gray200}>
      <TouchableOpacity onPress={onPressItem}>
        <View flexDirection="row" justifyContent="space-between" paddingX="12px" paddingBottom="8px" paddingTop="12px">
          <View>
            <Text text={item.name || item.auto_feeder_address} preset="title3" colorScheme={colorScheme} marginBottom="4px" color={color.palette.gray800} />
            <Text text={`AstoID: ${astoId}`} preset="body3" colorScheme={colorScheme} color={color.palette.gray700} />
          </View>
          {item?.state?.asto_wizard_finish && <TouchableOpacity onPress={onNavigateSetting}>
            <JalaIcon name="setting" size={22} color={color.palette.gray700} />
          </TouchableOpacity>}
        </View>
        <View paddingTop="10px" flexDirection="row" marginBottom="7px">
          <View width="30%" alignItems="center">
            <AutoImage source={asto} style={ASTO_IMAGE} />
          </View>
          <View width="70%" paddingRight="14px">
            <View flexDirection="row" justifyContent="space-between" borderBottomWidth={1} borderBottomColor={color.palette.gray200} paddingBottom="4px" marginBottom="4px">
              <Text tx="farmAutoFeederPondListScreen.playMode" preset="body3" colorScheme={colorScheme} color={color.palette.gray800} />
              <Text text={item.state?.mode ? translate(`farmAutoFeederPondListScreen.${item.state.mode}` as TxKeyPath) : '-'} preset="title5" colorScheme={colorScheme} color={color.palette.gray800} />
            </View>
            <View flexDirection="row" justifyContent="space-between" borderBottomWidth={1} borderBottomColor={color.palette.gray200} paddingBottom="4px" marginBottom="4px">
              <Text tx="autoFeederPondDetailScreen.startTime" preset="body3" colorScheme={colorScheme} color={color.palette.gray800} />
              <Text text={item.state?.startTime || '-'} preset="title5" colorScheme={colorScheme} color={color.palette.gray800} />
            </View>
            <View flexDirection="row" justifyContent="space-between" borderBottomWidth={1} borderBottomColor={color.palette.gray200} paddingBottom="4px" marginBottom="4px">
              <Text tx="autoFeederPondDetailScreen.endTime" preset="body3" colorScheme={colorScheme} color={color.palette.gray800} />
              <Text text={item.state?.endTime || '-'} preset="title5" colorScheme={colorScheme} color={color.palette.gray800} />
            </View>
            <View flexDirection="row" marginBottom="8px">
              <View flex={1}>
                <View>
                  <Text
                    tx="farmAutoFeederPondListScreen.lastUpdate"
                    preset="body3"
                    colorScheme={colorScheme}
                    color={color.palette.gray800}
                    textAlign="center"
                    isTruncated
                  />
                </View>
                <View>
                  <Text
                    text={lastUpdate}
                    preset="title5"
                    colorScheme={colorScheme}
                    color={color.palette.gray800}
                    textAlign="center"
                    isTruncated
                  />
                </View>
              </View>
              <View height="30px" width="1px" backgroundColor={color.palette.gray500} mx="4px" />
              <View flex={1} alignItems="center">
                <View>
                  <Text
                    tx="farmAutoFeederPondListScreen.lastUploaded"
                    preset="body3"
                    colorScheme={colorScheme}
                    color={color.palette.gray800}
                    textAlign="center"
                    isTruncated
                  />
                </View>
                <View>
                  <Text
                    text={lastUploaded}
                    preset="title5"
                    colorScheme={colorScheme}
                    color={needUpload ? "danger.500" : "gray.800"}
                    textAlign="center"
                    isTruncated
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
      {/* <CalibrationInfo */}
      {/*   model={model} */}
      {/*   borderBottomLeftRadius="8px" */}
      {/*   borderBottomRightRadius="8px" */}
      {/*   colorScheme={colorScheme} */}
      {/* /> */}
    </View>
  )
})

const Item: FC<{ colorScheme?: "light" | "dark", info: SectionListRenderItemInfo<any, any> }> = observer(function Item(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;

  const { item } = info
  const pondStore: PondStore = PondStoreModel.create(item.title)

  // const isShown = useCallback(() => {
  //   const { title } = item
  //   const isShown = !(title.pondId && hiddenPonds.includes(title.pondId))
  //   return isShown
  // }, [hiddenPonds, item])

  return (
    <View>
      <SectionHeader colorScheme={colorScheme} info={info} />
      {/* {isShown && ( */}
      <View
        paddingX="16px"
        paddingTop="12px"
      >
        <View>
          <View
            borderWidth="1px"
            borderRadius="8px"
            borderColor={`gray.${colorScheme === 'light' ? 200 : 800}`}
            backgroundColor={color.palette.white}
          >
            <View flexDirection="row" padding="12px" borderBottomWidth="1px" borderColor={`gray.${colorScheme === 'light' ? 200 : 800}`}>
              <View flex={1} flexDirection="row" alignItems="center" justifyContent="space-between">
                <Text flex={1} tx="farmAutoFeederPondListScreen.todayFeed" preset="body3" colorScheme={colorScheme} isTruncated />
                <Text text={`${pondStore.autoFeederPondTotalFeedToday || '-'} kg`} preset="title5" colorScheme={colorScheme} />
              </View>
              <View height="16px" width="1px" backgroundColor={color.palette.gray500} mx="8px" />
              <View flex={1} flexDirection="row" alignItems="center" justifyContent="space-between">
                <Text flex={1} tx="farmAutoFeederPondListScreen.nextDayFeed" preset="body3" colorScheme={colorScheme} isTruncated />
                <Text text={`${pondStore.autoFeederPondTotalFeedTomorrow || '-'} kg`} preset="title5" colorScheme={colorScheme} />
              </View>
            </View>
            {(item.data || []).map((autoFeeder, index) => <View key={`${item.title.pondId}-${index}`}>
              <AutoFeederitem item={autoFeeder} isLast={item.data.length - 1 === index} pondId={item.title.pondId} />
            </View>)}
          </View>
        </View>
      </View>
      {/* )} */}
      <SectionFooter colorScheme={colorScheme} info={info} />
    </View>
  )
})

const SectionFooter: FC<{ colorScheme?: "light" | "dark", info?: any }> = observer(function SectionFooter(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;

  return (
    <View py="8px">
      {info.item.data.length ? <View height="6px" backgroundColor={color.palette.gray200} /> : <View borderRadius="4px" alignItems="center" px="8px" py="16px">
        <Text tx="farmAutoFeederPondListScreen.noDevices" preset="body1" colorScheme={colorScheme}
              color={`gray.${colorScheme === "light" ? "600" : "400"}`} />
      </View>}
    </View>
  )
})

const EmptyState: FC<{ colorScheme?: "light" | "dark" }> = observer(function EmptyState(props) {
  const { colorScheme } = props
  const { height } = useWindowDimensions();

  const onPress = useCallback(() => {
    JalaAnalytic.log('Mobile App : Add Asto');
    navigate('Home.Stack', 'Home.AutoFeederPond.Create')
  }, [])

  return (
    <View flex={1} height={`${height-300}px`} justifyContent="space-between">
      <View alignItems="center" justifyContent="center" paddingTop="30px">
        <AutoImage source={empty} style={EMPTY_ASTO_IMAGE} />
        <Text tx="farmAutoFeederPondListScreen.emptyStateTitle" preset="title3" colorScheme={colorScheme} color={color.palette.gray800} />
        <Text tx="farmAutoFeederPondListScreen.emptyStateSubtitle" preset="body2" colorScheme={colorScheme} color={color.palette.gray800} />
        <Button style={EMPTY_BUTTON} tx="farmAutoFeederPondListScreen.emptyStateButton" textColor={color.palette.white} onPress={onPress} />
      </View>
      <View flexDirection="row" justifyContent="center" alignItems="center">
        <Text preset="body1" tx="farmAutoFeederPondListScreen.orderTitle" colorScheme={colorScheme} color={color.palette.gray800} marginRight="10px" />
        <TouchableOpacity>
          <Text preset="title3" tx="farmAutoFeederPondListScreen.orderButton" colorScheme={colorScheme} color={color.primary} />
        </TouchableOpacity>
      </View>
    </View>
  )
})

const FarmPicker: FC<{ colorScheme?: "light"|"dark", totalAsto?: number }> = memo(observer(function FarmPicker(props) {
  const { colorScheme = Appearance.getColorScheme(), totalAsto } = props
  const {
    appStore, appStore: { farmId, farmStore }
  } = useStores()
  const { initiating, farm } = farmStore || FarmStoreModel.create({})
  const { name } = farm || {}

  const onFarmChange = useCallback(async (value) => {
    appStore.set('farmId', value || null)
    await delay(1)
    if (appStore.farmStore) {
      appStore.farmStore.initWithLastBatchAndWaterQualityMultiMeasurements(() => {
        appStore.farmStore.getAutoFeederPonds()
      })
    }
  }, [appStore])

  const onPress = useCallback(() => {
    JalaAnalytic.log('Mobile App : Add Asto');
    navigate('Home.Stack', 'Home.AutoFeederPond.Create')
  }, [])

  return <View
    backgroundColor="white"
    borderBottomRadius="16px"
    paddingBottom="10px"
    zIndex={1}
    shadow={4}
  >
    <FormControl
      colorScheme={colorScheme}
      labelTx="homeScreen.farm"
      labelPreset="default"
      style={FORM_DROPDOWN}
    >
      <ModelPicker
        key={`${farmId || ''}-${name || ''}`}
        colorScheme={colorScheme}
        actionSheetColorScheme={colorScheme}
        placeholderTx="homeScreen.noFarm"
        Model={Farm}
        value={farmId}
        onValueChange={onFarmChange}
        isDisabled={(initiating || farmStore.loadingAutoFeederPond)}
        InputRightElement={(initiating || farmStore.loadingAutoFeederPond) && <Spinner mr="9px"></Spinner>}
      />
    </FormControl>
    <View flexDirection="row" justifyContent="space-between" alignItems="center" paddingX="16px">
      <Text text={`${totalAsto || '-'} ${translate("farmAutoFeederPondListScreen.asto")}`} preset="title4" color={color.palette.gray800} />
      <TouchableOpacity style={ADD_BUTTON} onPress={onPress}>
        <JalaIcon name="add" color={color.primary} size={15} />
        <Text tx="farmAutoFeederPondListScreen.addAsto" color={color.primary} preset="title4" marginLeft="5px" />
      </TouchableOpacity>
    </View>
  </View>
}));

export const FarmAutoFeederPondListScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function FarmAutoFeederPondListScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params } } = props

  const {
    appStore: {
      farmStore,
      farmStore: { loadingAutoFeederPond }
    },
    autoFeederPondStore: modelStore,
    autoFeederPondStore: { needRefresh },
  } = useStores()

  const [ refreshing, setRefreshing ] = useState<boolean>(false)
  // const [ hiddenPonds, setHiddenPonds ] = useState<Array<any>>([])
  const [ autoFeederSections, setAutoFeederSections ] = useState<Array<any>>([])
  const [ dataFiltered, setDataFiltered ] = useState<Array<any>>([])

  useEffect(() => {
    const interaction = InteractionManager.runAfterInteractions(() => {
      requestBluetoothConnectPermission()
        .then((granted) => granted && requestBluetoothScanPermission())
        .then((granted) => granted && requestAccessFineLocationPermission())
        .catch(() => false)
        .then((granted) => {
          if (!granted) Toast.show({ title: 'Please turn on all permission' });
        });
    })
    return interaction.cancel
  }, [])

  useEffect(() => {
    const interaction = InteractionManager.runAfterInteractions(() => {
      modelStore.init();
      if (!farmStore.syncedPond)
        farmStore.getPonds(true, () => {
          farmStore.getAutoFeederPonds().catch()
        }).catch();
      else
        farmStore.getPonds(false).then(() => {
          farmStore.getAutoFeederPonds().catch()
        }).catch();
    });
    return interaction.cancel
  }, [farmStore, modelStore])

  useFocusEffect(useCallback(() => {
    if (needRefresh) {
      farmStore.getAutoFeederPonds(true, () => {
        modelStore.set('needRefresh', null)
        modelStore.set('pushIdQueue', {})
      }).catch()
    }
  }, [farmStore, modelStore, needRefresh]))

  useFocusEffect(useCallback(() => {
    setAutoFeederSections((autoFeederSections) => {
      if (loadingAutoFeederPond) return autoFeederSections || [];
      const pondsData = farmStore.pondStoreModels.map((pondStore) => {
        return ({
          title: pondStore,
          data: pondStore.autoFeederPonds || [],
          // data: [ // Dummy
          //   {
          //     id: 1,
          //     auto_feeder_mac_address: 'ID 1',
          //     name: 'Name 1',
          //     updated_at: moment.utc().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
          //     state: {
          //       mode: 'continuous',
          //       feeds: [
          //         {
          //           quantity: 3,
          //           feed_at: moment().format('YYYY-MM-DD')
          //         }
          //       ]
          //     },
          //   },
          //   {
          //     id: 2,
          //     auto_feeder_mac_address: 'ID 2',
          //     name: 'Name 2',
          //     updated_at: moment.utc().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
          //     state: {
          //       mode: 'continuous',
          //       feeds: [
          //         {
          //           quantity: 3,
          //           feed_at: moment().format('YYYY-MM-DD')
          //         }
          //       ]
          //     },
          //   }
          // ]
        })
      });
      return pondsData.filter((pond) => pond.data.length !== 0)
    })
  }, [farmStore, loadingAutoFeederPond]))

  useFocusEffect(useCallback(() => {
    setDataFiltered(autoFeederSections.filter((datum) => (
      (datum.title.pond.name || '').toLowerCase().includes((params?.data?.text || '').toLowerCase())
    )))
  }, [autoFeederSections, params?.data?.text]))

  // const setItemShow = useCallback((pondId) => {
  //   const newArr = hiddenPonds
  //   if (newArr.includes(pondId)) {
  //     const index = newArr.indexOf(pondId);
  //     newArr.splice(index, 1); // remove item if it exists
  //   } else {
  //     newArr.push(pondId); // add item if it doesn't exist
  //   }
  //   return setHiddenPonds(newArr)
  // }, [hiddenPonds])

  const renderItem = useCallback((info) => (
    <Item colorScheme={colorScheme} info={info} />
  ), [colorScheme])

  const keyExtractor = useCallback((item, index) => {
    return `${index}`
  }, [])

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    farmStore.getPonds(true, () => {
      farmStore.getAutoFeederPonds(true, () => {
        setRefreshing(false);
      }).catch();
    }).catch();
  }, [farmStore])

  const astoDataLength = dataFiltered.map(item => item.data.length);

  const totalLength = astoDataLength.reduce((accumulator, length) => accumulator + length, 0);

  const edges = useMemo<Edge[]>(() => ['bottom'], [])

  // const flatData = dataFiltered.reduce((acc, section) => [...acc, ...section.data], []);
  return (<>
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundBar={colorScheme === 'light' ? color.primary : undefined}
      backgroundColor={color.palette.white}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      <FarmPicker colorScheme={colorScheme} totalAsto={totalLength} />
      <FlatList
        bounces={false}
        data={dataFiltered}
        renderItem={renderItem}
        ListEmptyComponent={<EmptyState />}
        keyExtractor={keyExtractor}
        ListFooterComponent={<SafeAreaView edges={edges} />}
        onRefresh={onRefresh}
        contentContainerStyle={FLAT_LIST}
        refreshing={!!(refreshing || farmStore.loadingAutoFeederPond)}
      />
    </Screen>
    <OfflineMode colorScheme={colorScheme} navigation />
  </>)
})
